import { Card, Divider, Grid, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useApplicationId } from '../../../hooks/useApplicationId';
import { usePreworkMentorApplicationsList } from './usePreworkMentorApplicationsList';
import { Filter } from './Filter';
import { ApplicationsList } from './ApplicationsList';
import { useCallback } from 'react';
import { ApplicationSummary } from '../../../shared/VolunteerApplicationServiceTypes';
import { PRE_WORK_MENTOR_CONTEXT } from '../../../shared/Routes';
import moment from 'moment';

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const PreworkMentorApplicationsListContainer = () => {
	const {
		applicationsList,
		onPageChange,
		filter,
		onFilterChange,
		paging,
		selectedBatch,
	} = usePreworkMentorApplicationsList();
	const { navigateWithApplicationId } = useApplicationId();
	const { t } = useTranslation();
	const screens = useBreakpoint();
	const isMobile = !screens.sm;
	const resultDate = selectedBatch?.snpResultDateForCandidate;
	const batchName = selectedBatch?.name;

	const handleEvaluateClick = useCallback(
		(application: ApplicationSummary) => {
			navigateWithApplicationId(
				PRE_WORK_MENTOR_CONTEXT,
				application.applicationId
			);
		},
		[navigateWithApplicationId]
	);

	const filterComponent = filter && (
		<div className="mb-[16px]">
			<Filter value={filter} onFilterChange={onFilterChange} />
		</div>
	);

	const isAfter90Days = resultDate
		? moment().isAfter(moment(resultDate).add(90, 'days'))
		: false;

	const formattedResultDate = resultDate
		? moment(resultDate).format('Do MMM, YYYY')
		: '';

	if (isAfter90Days) {
		return (
			<Card className="w-full md:w-[50%] mx-auto mt-10 px-6 py-8 pt-2 font-sans shadow-lg">
				<div className="flex flex-col items-center text-center space-y-4">
					<div className="text-red-600 font-semibold text-lg">
						{t('preworkConfirmationTimelineEnded')}
					</div>
					<Divider />
					<Text className="text-base text-gray-700">
						{t('thePreworkEvaluationPeriodHasEnded', {
							batchName,
							resultDate: formattedResultDate,
						})}
					</Text>
				</div>
			</Card>
		);
	}

	return (
		<div className="flex flex-col p-[16px]">
			<div className="flex gap-8">
				<Text className="hidden md:block font-sans font-bold text-xl text-secondary-black mb-4 whitespace-nowrap">
					{t('listOfCandidates')}
				</Text>
			</div>
			<div className={isMobile ? '' : 'flex items-center justify-between'}>
				{filterComponent}
			</div>
			<ApplicationsList
				data={applicationsList}
				onPageChange={onPageChange}
				onEvaluateClick={handleEvaluateClick}
				pageConfig={paging}
			/>
		</div>
	);
};
